import { StyleSheet, View , Platform } from 'react-native';
import Svg from '@sharedComponents/SvgImage/Svg';
import { BASE_IMAGE_URL } from '@app/configs/constants';
import { ThemedText, ThemedView } from '@app/theme';




const WhyVoltSection = () => {
  return (
    <ThemedView 
      flexDirection='row'
      borderRadius='lg'
      borderWidth={1}
      borderColor='border-primary'
      mx="lg"
      mb="lg"
      backgroundColor='bg-surface-primary'
    >
      <ThemedView style={styles.flashImageContainer}>
        <ThemedView style={styles.imageRender}>
          <Svg url={BASE_IMAGE_URL + 'flash_icon.svg'} height={46} width={46} />
        </ThemedView>
        <ThemedView>
         <ThemedText textAlign='center' color='text-secondary' variant='b4m'>Instant and{'\n'}hassle-free</ThemedText>
        </ThemedView>
      </ThemedView>
      <ThemedView style={styles.divider} />
      <ThemedView style={styles.rateImageContainer}>
        <ThemedView style={styles.imageRender}>
          <Svg url={BASE_IMAGE_URL + 'rate_icon.svg'} height={46} width={46} />
        </ThemedView>
        <ThemedView style={styles.rateTextRender}>
         <ThemedText textAlign='center' color='text-secondary' variant='b4m'>Low interest {'\n'}rate</ThemedText>
        </ThemedView>
      </ThemedView>
      <ThemedView style={styles.divider} />
      <ThemedView style={styles.securityImageContainer}>
        <ThemedView style={styles.imageRender}>
          <Svg url={BASE_IMAGE_URL + 'security_icon.svg'} height={46} width={46} />
        </ThemedView>
        <ThemedView style={styles.securityTextRender}>
          <ThemedText textAlign='center' color='text-secondary' variant='b4m'>Secure & {'\n'}transparent</ThemedText>
        </ThemedView>
      </ThemedView>
    </ThemedView>
  );
};

export default WhyVoltSection;

const styles = StyleSheet.create({
  
  flashImageContainer: {
    paddingLeft: Platform.OS === 'web' ? 24 : 16,
    paddingVertical: 20,
    alignItems: 'center',
    justifyContent: 'center',
    width: '30%',
  },
  rateImageContainer: {
    paddingVertical: 20,
    alignItems: 'center',
    justifyContent: 'center',
    width: '30%',
  },
  securityImageContainer: {
    paddingRight: Platform.OS === 'web' ? 24 : 16,
    paddingVertical: 20,
    alignItems: 'center',
    justifyContent: 'center',
    width: '30%',
  },
  imageRender: {
    marginBottom: 4,
  },
  rateTextRender: {
    paddingHorizontal: 10,
    justifyContent: 'center',
    alignContent: 'center',
  },
  rateText: {
    flexDirection: 'row',
  },
  securityTextRender: {
    paddingHorizontal: 10,
  },
  divider: {
    marginHorizontal: 10,
    borderWidth: 1,
    borderColor: '#F3F5FC',
    marginVertical: 37,
  },
});
